export enum WaterMeterDetailField {
  SecondSerialNumber = 'secondSerialNumber',
  MeasurementType = 'measurementType',
  HotWater = 'hotWater',
  Flange = 'flange',
  Woltman = 'woltman',
  Orientation = 'orientation',
  Flowrate = 'flowrate',
  LayLength = 'layLength',
  DiameterNominal = 'diameterNominal',
  TubeMaterial = 'tubeMaterial',
}
